import { render, staticRenderFns } from "./OwlRadio.vue?vue&type=template&id=2ba67e08"
import script from "./OwlRadio.vue?vue&type=script&lang=js"
export * from "./OwlRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports